import {
    NineSlicePlane,
    Texture,
} from 'pixi.js';
import { Button, TextSettings } from './Button';

export interface NineSliceOpts
{
    texture: Texture;
    frame: number;
    width: number;
    height: number;
}

export class NineSliceButton extends Button
{
    constructor(opts: NineSliceOpts, text?: TextSettings)
    {
        super(null, text);

        this.sprite = new NineSlicePlane(opts.texture, opts.frame, opts.frame, opts.frame, opts.frame);
        this.sprite.width = opts.width;
        this.sprite.height = opts.height;
        this.sprite.position.set(-opts.width / 2, -opts.height / 2);
        this.addChildAt(this.sprite, 0);
    }
}